// custom pages
import config from "config/config";
import HandleApiResponse from "utils/handleApiResponse";

const addemploymentinfo = () => {
  const { handleResponse, handleError } = HandleApiResponse();

  async function getAlldesignationAPI() {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      };
      const res = await fetch(`${config.host}/panel/designations/findAll`, obj);
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getAlldepartmentAPI() {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      };
      const res = await fetch(`${config.host}/panel/departments/findAll`, obj);
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getAllemployementtypeAPI() {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      };
      const res = await fetch(
        `${config.host}/panel/employmentTypes/findAll`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getAllworklocationAPI() {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      };
      const res = await fetch(
        `${config.host}/panel/workLocations/findAll`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getAllexperiencesAPI() {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      };
      const res = await fetch(`${config.host}/panel/experiences/findAll`, obj);
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getAllRolesAPI() {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      };
      let res = await fetch(`${config.host}/panel/roles/findAll`, obj);
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getEmployementcreateAPI(data) {
    try {
      const obj = {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
      let res = await fetch(
        `${config.host}/panel/employees/updateEmployement`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getEmployeeResignStatusAPI() {
    try {
      const obj = {
        method: "GET",
        credentials: "include", // Adjust as per your authentication strategy
        headers: {
          "Content-Type": "application/json",
        },
      };
      let res = await fetch(`${config.host}/panel/ems/employeeExitDetails`, obj);
      return handleResponse(res); // Assuming `handleResponse` processes the API response
    } catch (err) {
      handleError(err); // Assuming `handleError` handles any errors
    }
  }

  return {
    getAlldesignationAPI,
    getAlldepartmentAPI,
    getAllemployementtypeAPI,
    getAllworklocationAPI,
    getAllexperiencesAPI,
    getEmployementcreateAPI,
    getAllRolesAPI,
    getEmployeeResignStatusAPI,
  };
};

export default addemploymentinfo;
